<template>
	<div class="banner" v-loading="loading">
		<el-carousel height="100%" trigger="click">
			<el-carousel-item v-for="(item, i) in list" :key="i">
				<a
					v-if="item.externalUrl"
					:href="item.externalUrl"
					target="_blank"
					rel="noopener noreferrer"
					class="banner-link"
				>
					<img :src="item.url" style="width:100%;">
				</a>
				<img v-else :src="item.url" style="width:100%;">
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			loading: true,
		}
	},
	computed: {
		...mapState("home", [
			"_banner",
		]),
		list() {
			return this._banner.list || new Array;
		},
	},
	methods: {
		...mapActions("home", [
			"_getData",
		]),
	},
	async mounted() {
		if (!this.list.length) await this._getData("banner");
		this.loading = false;
	},
}
</script>

<style lang="scss" scoped>
.banner {
	position: relative;
	@media screen and (min-width: 769px) {
		clip-path: polygon(0 0, 100% 0, 100% 95%, 55% 100%, 21% 97%, 0 100%);
	}

	&::before {
		content: "";
		display: block;
		padding-top: 40%;
	}

	.el-carousel {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.el-carousel__item {
		background: #fefefe;
	}

	.banner-link {
		display: block;
		width: 100%;
		height: 100%;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
